class FormStock extends HTMLElement {
  connectedCallback() {
    this.setUpStockAlertEvents();
  }

  setUpStockAlertEvents() {
    const formElement = this.querySelector("#kl_stock_alert");
    const submitButton = this.querySelector("#kl_stock_alert-btn");
    const successMessage = this.querySelector(".kl_stock_alert-success");
    const errorMessage = this.querySelector(".kl_stock_alert-error");

    if (!formElement || !submitButton) return;

    formElement.addEventListener("submit", async (event) => {
      event.preventDefault();

      const originalText = submitButton.textContent;

      submitButton.disabled = true;
      submitButton.textContent = "Submitting...";

      submitButton.disabled = true;
      submitButton.setAttribute("aria-busy", "true");

      successMessage?.classList.add("hidden");
      errorMessage?.classList.add("hidden");
      errorMessage.textContent = "";

      try {
        const bisRes = await this.subscribeProductStockToKlaviyo(formElement);
        if (!bisRes || !bisRes.ok) {
          const payload = bisRes ? await bisRes.json().catch(() => null) : null;
          const msg =
            payload?.errors?.[0]?.detail || "Back in stock request failed";
          throw new Error(msg);
        }

        const subscribeToMailingList =
          formElement.querySelector('input[name="list_subscribe"]')?.checked ||
          false;

        const marketingRes = subscribeToMailingList
          ? await this.pdpKlaviyoAddPropertyAndSubscribeToList(formElement)
          : await this.pdpKlaviyoAddProperty(formElement);

        if (!marketingRes || !marketingRes.ok) {
          const payload = marketingRes
            ? await marketingRes.json().catch(() => null)
            : null;
          const msg = payload?.errors?.[0]?.detail || "Profile update failed";
          throw new Error(msg);
        }

        successMessage.textContent =
          "You’re signed up. We’ll notify you when it's back in stock.";
        successMessage.classList.remove("hidden");

        formElement.reset();
      } catch (e) {
        errorMessage.textContent = `Failed to subscribe: ${e.message}`;
        errorMessage.classList.remove("hidden");
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = originalText;

        submitButton.disabled = false;
        submitButton.removeAttribute("aria-busy");
      }
    });
  }

  subscribeProductStockToKlaviyo(formElement) {
    const co = "UYwKnY";
    const email =
      formElement.querySelector('input[name="user_email"]')?.value || "";
    const variant =
      formElement.querySelector('input[name="variant"]')?.value || "";

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2024-07-15",
        "content-type": "application/json",
        Authorization: `Klaviyo-API-Key ${co}`,
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: { type: "profile", attributes: { email } },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variant}`,
              },
            },
          },
        },
      }),
    };

    return fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${co}`,
      options
    );
  }

  pdpKlaviyoAddProperty(formElement) {
    const co = "UYwKnY";
    const user_email =
      formElement.querySelector('input[name="user_email"]')?.value || "";
    const mkt_custom_property_name =
      formElement.querySelector('input[name="mkt_custom_property_name"]')
        ?.value || "";

    const signUpSource =
      Shopify?.country === "GB" ? "UK" : Shopify?.country || "US";

    const klaviyoProperties = {
      [mkt_custom_property_name]: "true",
      updateable_source: signUpSource,
    };

    const options = {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: "2025-01-15",
        "content-type": "application/vnd.api+json",
        Authorization: `Klaviyo-API-Key ${co}`,
      },
      body: JSON.stringify({
        data: {
          type: "profile",
          attributes: {
            properties: klaviyoProperties,
            email: user_email,
          },
        },
      }),
    };

    return fetch(
      `https://a.klaviyo.com/client/profiles/?company_id=${co}`,
      options
    );
  }

  pdpKlaviyoAddPropertyAndSubscribeToList(formElement) {
    const co = "UYwKnY";
    const id_list =
      formElement.querySelector('input[name="kl_list"]')?.value || "";
    const user_email =
      formElement.querySelector('input[name="user_email"]')?.value || "";
    const mkt_custom_property_name =
      formElement.querySelector('input[name="mkt_custom_property_name"]')
        ?.value || "";

    const signUpSource =
      Shopify?.country === "GB" ? "UK" : Shopify?.country || "US";

    const klaviyoProperties = {
      [mkt_custom_property_name]: "true",
      ad_personalization: "granted",
      ad_user_data: "granted",
      "Accepts Marketing": "true",
      updateable_source: signUpSource,
    };

    const options = {
      method: "POST",
      headers: {
        revision: "2024-07-15",
        "content-type": "application/json",
        Authorization: `Klaviyo-API-Key ${co}`,
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  properties: klaviyoProperties,
                  email: user_email,
                },
              },
            },
            custom_source: "PDP stock alert subscribe button",
          },
          relationships: { list: { data: { type: "list", id: id_list } } },
        },
      }),
    };

    return fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${co}`,
      options
    );
  }
}

if (!customElements.get("form-stock")) {
  customElements.define("form-stock", FormStock);
}
